<template>
  <section class="section">
    <div class="container">
      <div class="row">
          <div class="text-center center-block">
            <a class="btn btn-success btn-fill" data-toggle="modal" data-target=".modal-pedido">Nuevo pedido</a>
          </div>  
        </div>     
      <div class="row">
        <div class="col-xs-12 col-sm-4 col-md-3">
          <div class="form-group">
            <label for="">Fecha</label>
            <date-picker v-model="fechaActiva" />
          </div>
        </div>
        <div class="col-xs-12 col-sm-3 col-md-2">
          <label for="">Número</label>
          <input type="text" class="form-control" v-model="filtros.numero">
        </div>
        <div class="col-xs-12 col-sm-4 col-md-3">
          <div class="form-group">
            <label for="">Sucursal</label>
            <select name="" id="" class="form-control" v-model="filtros.sucursal">
              <option value="">Todas</option>
              <option :value="sucursal._id" v-for="sucursal in sucursalesFiltro" :key="sucursal._id">{{sucursal.empresa.razonSocial}}-{{sucursal.denominacion}}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-4 col-md-3">
            <div class="form-group">
              <label for="">Usuario</label>
              <input type="text" class="form-control" v-model="filtros.usuario">
            </div>
          </div>
        </div>
           
      </div>
      <div class="row" v-if="entregas.length > 0">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Número</th>
              <th>Fecha</th>
              <th>Para</th>
              <th>Proveedor</th>
              <th>Cliente</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entrega in entregasFiltradas" :key="entrega._id">
              <td>{{entrega.numero}}</td>
              <td>{{entrega.fechaEntrega | fechaCorta}}</td>
              <td>{{entrega.usuario.displayName}}</td>
              <td>{{entrega.proveedor.razonSocial}}</td>
              <td>{{entrega.sucursal.empresa.razonSocial}}-{{entrega.sucursal.denominacion}}</td>
              <td>
                <select @change="onChangeEstadoPedido(entrega._id, entrega.proveedor._id, $event)" class="form-control" :value="entrega.estado">
                    <option value="Recibido">Recibido</option>
                    <option value="Cocina">Cocina</option>
                    <option value="Empaquetado">Empaquetado</option>
                    <option value="Despachado">Despachado</option>
                    <option value="Entregado">Entregado</option>
                    <option value="Cancelado">Cancelado</option>
                  </select>
              </td>
              <td>
                <!--
                <div class="btn-group" style="margin-right: .5em;">
                  <button class="btn btn-default status-recibido btn-xs">Re</button>
                  <button class="btn btn-default status-cocina btn-xs">Co</button>
                  <button class="btn btn-default status-empaquetado btn-xs">Em</button>
                  <button class="btn btn-default status-despachado btn-xs">De</button>
                  <button class="btn btn-default status-entregado btn-xs">En</button>
                  <button class="btn btn-default status-cancelado btn-xs">Ca</button>
                </div>
                -->
                  
                <div class="btn-group">
                  <button class="btn btn-default btn-xs">+</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" v-else>
        <div class="text-center center-block">
          <span class="label label-danger">No hay pedidos para la fecha seleccionada</span>
        </div>
      </div>
    </div>
    <div class="modal modal-pedido" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-header">
          <h4>Crear nuevo pedido para el {{fechaActiva | fechaDMA}}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6">
            <div class="form-group">
              <label for="">Empresa</label>
              <select name="" id="" class="form-control" @change="onChangeEmpresaPedido" v-model="pedido.sucursal">
                <option :value="sucursal._id" v-for="sucursal in sucursales" :key="sucursal._id">{{sucursal.empresa.razonSocial}}-{{sucursal.denominacion}}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6">
            <label for="">Usuario</label>
            <select name="" class="form-control" id="" ref="slUsuariosEmpresa" v-model="pedido.usuario">
              <option value="">Seleccione un usuario</option>
              <option :value="usuario._id" v-for="usuario in usuariosEmpresaSeleccionada" :key="usuario._id">{{usuario.displayName}}</option>
            </select>
            <span class="label label-warning" v-if="pedidosUsuario.length > 0">El usuario ya tiene {{pedidosUsuario.length}} pedidos para esta fecha</span>
          </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6">
              <div class="form-group">
                <label for="">Combo</label>
                <select name="" id="" class="form-control" v-model="pedido.combo">
                  <option value="">Seleccione un combo</option>
                  <option :value="combo._id" v-for="combo in combosUsuario" :key="combo._id" @select="onChangeCombo(combo)">{{combo.combo.nombre}}</option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6">
              <div class="form-group">
                <label for="">Precio</label>
                <input type="text" class="form-control derecha" ref="precio">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6">
              <div class="form-group">
                <label for="">Estado</label>
                <select class="form-control" v-model="pedido.estado">
                  <option value="Recibido">Recibido</option>
                  <option value="Cocina">Cocina</option>
                  <option value="Empaquetado">Empaquetado</option>
                  <option value="Despachado">Despachado</option>
                  <option value="Entregado">Entregado</option>
                  <option value="Cancelado">Cancelado</option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6">
              <div class="form-group">
                <label for="">Subsidio(%)</label>
                <input type="number" min="0" max="100" class="form-control derecha" ref="subsidio">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-md-12">
              <template  v-for="platosEnCategoria, idx in menuActivo">
                <h4>{{idx}} ({{totalEnCategoria(platosEnCategoria)}})</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Cantidad</th>
                      <th>Plato</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="plato in platosEnCategoria" :key="plato._id">
                      <td class="col-xs-2"><input class="form-control derecha" type="number" min="0" max="9999" value="0" @change="onChangeCantidadPlato(plato, $event)"></td>
                      <td>{{plato.nombre}}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                  </tfoot>
                </table>
            </template>
            </div>
          </div>
        </div>
        <div class="modal-footer text-center center-block">
          <ul class="list-unstyled">
            <li v-for="error in errores" :key="error">
              <span class="label label-danger">{{error}}</span>
            </li>
          </ul>
          <div class="clearfix">
            <small>{{getMultiplicador}} pedidos</small>
          </div>
          <div class="row">
            <div class="btn-group">
              <button class="btn btn-success btn-fill" @click.prevent="guardarEntrega">Guardar</button>
              <button class="btn btn-fill-danger" @click.prevent="onCloseModal">Cancelar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import '../../assets/css/select2_status.css'
import '../../assets/css/select2.css'
import DatePicker from '../Shared/DatePicker'
import {uniqBy, groupBy, sortBy} from 'lodash'
import moment from 'moment'
import $ from 'jquery'
import 'select2'

moment.locale('es')

export default {
  components: {
    'date-picker': DatePicker
  },
  computed: {
    comboActivo () {
      const me = this
      if (me.combosUsuario.length < 1) {
        return null
      }
      return me.combosUsuario.find(c => c._id === me.pedido.combo)
    },
    combosUsuario () {
      const me = this
      let combos = []
      if (!me.pedido.sucursal) return []
      const sucursal = me.sucursales.find(sucursal => sucursal._id === me.pedido.sucursal)
      sucursal.proveedores.forEach((proveedor) => {
        const proveedorActivo = me.proveedores.find(p => p._id === proveedor.proveedor)
        const combo = proveedorActivo.precios.find(p => p.combo._id === proveedor.combo)
        combo.proveedor = proveedorActivo._id
        combos.push(combo)
      })
      return combos
    },
    datosEntrega () {
      const me = this
      const sucursal = me.sucursales.find(s => s._id === me.pedido.sucursal)
      const combo = sucursal.proveedores.find(p => p.combo === me.comboActivo.combo._id)
      return {
        proveedor: me.proveedorActivo,
        costoDelivery: 0,
        estado: me.pedido.estado,
        fechaEntrega: me.fechaActiva,
        horaEntrega: combo.horarioAsignado,
        usuario: me.pedido.usuario,
        combo: me.comboActivo.combo._id,
        multiplicador: me.getMultiplicador,
        sucursal: me.pedido.sucursal,
        platos: me.pedido.platos,
        precio: parseFloat(me.$refs.precio.value),
        porcentajeSubsidio: parseFloat(me.$refs.subsidio.value)
      }
    },
    entregasFiltradas () {
      const me = this
      let entregas = me.entregas
      if (me.filtros.numero) {
        entregas = entregas.filter(entrega => entrega.numero.toString().includes(me.filtros.numero))
      }
      if (me.filtros.sucursal) {
        entregas = entregas.filter(entrega => entrega.sucursal._id === me.filtros.sucursal)
      }
      if (me.filtros.usuario) {
        entregas = entregas.filter(entrega => entrega.usuario.displayName.toLowerCase().includes(me.filtros.usuario.toLowerCase()))
      }
      return entregas
    },
    getMultiplicador () {
      const me = this
      let multiplicador = 0
      if (!me.comboActivo) {
        return multiplicador
      }
      const reglas = me.comboActivo.combo.reglas
      let multiplicadores = []
      reglas.forEach((regla) => {
        let contador = 0
        me.pedido.platos.forEach(p => {
          if (p.plato.categoria._id === regla.categoria) {
            contador += p.cantidad
          }
        })
        multiplicadores.push(contador / regla.cantidad)
      })
      multiplicador = Math.max(...multiplicadores)
      return multiplicador
    },
    menuActivo () {
      const me = this
      if (!me.pedido.sucursal || !me.comboActivo) {
        return []
      }
      const categorias = me.comboActivo.combo.reglas.map(r => r.categoria)
      const menusProveedor = me.menus.filter(menu => {
        return menu.proveedor === me.proveedorActivo
      })
      const todosPlatos = []
      menusProveedor.forEach(m => {
        m.platos.forEach(p => todosPlatos.push(p))
      })
      const platos = todosPlatos.filter(plato => categorias.includes(plato.categoria._id))
      const platosAgrupados = groupBy(platos, (plato) => {
        return plato.categoria.nombre
      })
      return platosAgrupados
    },
    pedidosUsuario () {
      const me = this
      if (!me.pedido.usuario || !me.comboActivo) return []
      return me.entregas.filter(e => e.usuario._id === me.pedido.usuario && e.estado !== 'Cancelado' && e.combo === me.comboActivo.combo._id)
    },
    subsidioActivo () {
      let subsidio = 0
      const nombreDia = moment(this.fechaActiva).format('dddd')
      if (this.subsidiosActivos) {
        subsidio = this.subsidiosActivos[nombreDia]
      }
      return subsidio
    },
    subsidiosActivos () {
      const me = this
      let subsidio = {}
      if (!me.comboActivo || !me.proveedorActivo || !me.sucursalActiva) {
        return subsidio
      }
      const proveedorActivo = me.proveedorActivo
      const combo = me.comboActivo.combo._id || null
      if (me.sucursalActiva && proveedorActivo && combo) {
        const proveedor = me.sucursalActiva.proveedores.find(p => {
          return p.proveedor === proveedorActivo && p.combo === combo
        })
        if (proveedor && proveedor.subsidio) subsidio = proveedor.subsidio
      }
      return subsidio
    },
    sucursalActiva () {
      return this.sucursales.find(s => s._id === this.pedido.sucursal)
    },
    sucursalesFiltro () {
      const me = this
      let sucursales = []
      if (me.entregas.length > 0) {
        const sucursalesEntregas = me.entregas.map(entrega => entrega.sucursal)
        sucursales = uniqBy(sucursalesEntregas, (sucursal) => sucursal._id)
      }
      return sortBy(sucursales, s => s.empresa.razonSocial)
    },
    usuarioPedido () {
      const me = this
      if (!me.pedido.usuario) {
        return null
      }
      return me.usuariosEmpresaSeleccionada.find(u => u._id === me.pedido.usuario)
    }
  },
  data () {
    return {
      cargandoUsuarios: false,
      entregas: [],
      errores: [],
      fechaActiva: null,
      menus: [],
      menuVacio: false,
      pedido: {
        combo: null,
        sucursal: null,
        platos: [],
        usuario: null,
        estado: 'Recibido'
      },
      proveedorActivo: null,
      proveedores: [],
      sucursales: [],
      usuariosEmpresaSeleccionada: [],
      filtros: {
        numero: '',
        sucursal: null,
        usuario: ''
      },
      slUsuarios: null
    }
  },
  filters: {
    fechaDMA (value) {
      return moment(value).format('DD/MM/YY')
    },
    fechaCorta (value) {
      return moment(value).format('DD/MM/YY HH:mm')
    },
    lower (value) {
      return `status-${value.trim().toLowerCase()}`
    },
    serializarReglas (combo) {
      if (!combo) return ''
      return combo.combo.reglas.map(r => `${r.cantidad} ${r.categoria}`)
    }
  },
  methods: {
    cargarUsuariosEmpresaSeleccionada (idSucursal) {
      const me = this
      me.cargandoUsuarios = true
      if (!idSucursal) {
        me.usuariosEmpresaSeleccionada = []
        return false
      }
      me.$store.dispatch('getUsuariosActivosEmpresa', idSucursal).then(({body}) => {
        console.log(body)
        me.cargandoUsuarios = false
        me.usuariosEmpresaSeleccionada = sortBy(body.usuarios, u => u.displayName)
        console.log(me.usuariosEmpresaSeleccionada)
      }, e => {
        me.cargandoUsuarios = false
        console.error(e)
      }).then(() => {
        console.log('en el then')
        me.slUsuarios = $(me.$refs.slUsuariosEmpresa)
          .select2()
          .on('change', (e) => {
            me.pedido.usuario = e.target.value
          })
      })
    },
    clearPedido () {
      this.pedido.platos = []
      this.pedido.usuario = null
      this.pedido.multiplicador = 1
      this.pedido.combo = null
      this.pedido.sucursal = null
    },
    cumpleReglas () {
      const me = this
      let resultado = true
      if (me.pedido.platos.length === 0) return false
      const reglas = me.comboActivo.combo.reglas
      let multiplicadores = []
      reglas.forEach((regla) => {
        let contador = 0
        me.pedido.platos.forEach(p => {
          if (p.plato.categoria._id === regla.categoria) {
            contador += p.cantidad
          }
        })
        multiplicadores.push(contador / regla.cantidad)
      })
      const sonIguales = me.sonTodosIguales(multiplicadores)
      if (!sonIguales) {
        alert('No coinciden las cantidades por categoría')
        return false
      }
      const esAdmin = me.usuarioPedido.roles.includes('admincliente')
      if (!esAdmin && multiplicadores[0] !== 1) {
        alert('Los usuarios normales solo pueden hacer un pedido por vez')
        resultado = false
      }
      return resultado
    },
    sonTodosIguales (arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== arr[0]) return false
      }
      return true
    },
    getPedidosDia (fecha) {
      const me = this
      const datos = {
        fecha: fecha
      }
      this.$store.dispatch('getTodosPedidosDia', datos)
        .then(({body}) => {
          me.entregas = sortBy(body.entregas, e => e.numero * -1)
          me.menus = body.menus
        })
        .catch(e => console.error(e))
    },
    guardarEntrega () {
      const me = this
      const errores = []
      if (!me.pedido.usuario) {
        errores.push('No hay un usuario seleccionado')
      }
      if (!me.pedido.combo) {
        errores.push('No hay un combo seleccionado')
      }
      if (!me.pedido.sucursal) {
        errores.push('No hay una sucursal seleccionada')
      }
      if (!me.cumpleReglas()) {
        errores.push('No se cumplen las reglas del pedido')
      }
      if (errores.length === 0) {
        me.$http.post('/api/admin/pedidoroot', me.datosEntrega).then(({body}) => {
          me.onCloseModal()
          me.getPedidosDia(me.fechaActiva)
        }, e => console.log(e))
      }
      this.errores = errores
    },
    obtenerPrecio (value) {
      if (value && value.precio) {
        return value.precio
      }
      return 0
    },
    onChangeCantidadPlato (plato, event) {
      const me = this
      const existePlato = me.pedido.platos.find(p => p.plato._id === plato._id)
      const cantidad = parseInt(event.target.value)
      if (existePlato) {
        existePlato.cantidad = cantidad
      } else {
        me.pedido.platos.push({
          plato: plato,
          cantidad: cantidad
        })
      }
    },
    onChangeCombo (combo) {
      console.log('onChangeCombo', combo)
    },
    onChangeEmpresaPedido (e) {
      this.cargarUsuariosEmpresaSeleccionada(e.target.value)
      this.$refs.precio.value = ''
      this.$refs.subsidio.value = ''
    },
    onChangeEstadoPedido (id, proveedor, event) {
      const me = this
      const options = {
        ids: [id],
        estado: event.target.value,
        proveedor: proveedor
      }
      me.$http.post('/api/admin/cambiarestado', options).then(({body}) => {
        const ids = body.ids
        me.entregas.forEach((entrega, idx) => {
          if (ids.includes(entrega._id)) {
            entrega.estado = body.estado
          }
        })
      }, e => me.$emit('mostrar-notificacion', 'error', e))
    },
    onCloseModal () {
      this.pedido = {
        combo: null,
        sucursal: null,
        platos: [],
        usuario: null
      }
      if (this.slUsuarios) $(this.$refs.slUsuariosEmpresa).select2('destroy')
      $('.modal').modal('hide')
    },
    totalEnCategoria (platos) {
      const me = this
      let acumulador = 0
      platos.forEach(p => {
        me.pedido.platos.forEach(plato => {
          if (plato.plato._id === p._id) acumulador += plato.cantidad
        })
      })
      return acumulador
    }
  },
  mounted () {
    const me = this
    me.$store.dispatch('initAdminRoot').then(({body}) => {
      me.proveedores = sortBy(body.proveedores, p => p.razonSocial)
      me.sucursales = sortBy(body.sucursales, s => s.empresa.razonSocial)
      me.fechaActiva = new Date()
    }, e => console.error(e))
  },
  watch: {
    fechaActiva (newVal, oldVal) {
      if (newVal) {
        this.getPedidosDia(newVal)
      } else {
        this.entregas = []
      }
    },
    'pedido.combo': function (newVal, oldVal) {
      const me = this
      const combo = me.combosUsuario.find(c => c._id === newVal)
      if (combo) {
        me.proveedorActivo = combo.proveedor
        me.$refs.precio.value = me.obtenerPrecio(me.comboActivo)
        me.$refs.subsidio.value = me.subsidioActivo
      }
      me.pedido.platos = []
    }
  }
}
</script>
<style scoped>
.modal-backdrop.in {
  display:none!important;
  z-index: 0!important;
}
.modal {
  background-color: white;
  z-index: 1050;
}
.derecha {
  text-align: right;
}
.status-recibido {
  background-color: #F28893;
  color: #333;
}
.status-cocina {
  background-color: #FFC182;
  color: #333;
}
.status-empaquetado {
  background-color: #74A9B3;
  color: #333;
}
.status-entregado {
  background-color: #93A512;
  color: #333;
}
.status-cancelado {
  background-color: #666;
  color: #FFF;
}

</style>



// WEBPACK FOOTER //
// AdminPedidosRoot.vue?31782db6